import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Dialog } from '@headlessui/react';
import { toast } from 'react-hot-toast';

import { Button } from '../../../components/buttons/Button';
import { Modal } from '../../../components/modal/Modal';

import { requestCreate } from '../../../redux/actions/request';
import { ComboBoxSearch } from '../../../components/comboBoxSearch/comboBoxSearch';
import { getTotalRequestStudentsPending } from '../../../redux/actions/analytics';

export const ModalAddStudentToCourse = ({ open, setOpen, idCourse }) => {
    const dispatch = useDispatch();
    const cancelButtonRef = useRef(null);
    const [loadingAddStudent, setLoadingAddStudent] = useState(false);
    const [action, setAction] = useState('')

    const [formData, setFormData] = useState({
        student: '',
    });

    const user = useSelector((state) => state.user);
    const { user: { typeUser, _id: userId } } = user;

    useEffect(() => {
        if (!open) {
            setFormData({
                student: ''
            });
        }
    }, [open]);

    useEffect(() => {
        if (user) {
            setAction(typeUser === 'control escolar' ? 'request' : 'execute')
        }
    }, [user, typeUser]);

    const handleAddStudentToCourse = () => {
        setLoadingAddStudent(true);
        const { student } = formData;
        if (student === '') {
            toast.error('Selecciona un estudiante');
            setLoadingAddStudent(false);
            return;
        }

        dispatch(requestCreate(student.id, userId, 'add', [idCourse]))
            .then((result) => {
                if (result.status === 201) {
                    toast.success(result.message);
                    dispatch(getTotalRequestStudentsPending('pending'));
                    setOpen(false);
                    setFormData({
                        student: ''
                    });
                } else {
                    toast.error(result.message);
                }
                setLoadingAddStudent(false);
            });
    }

    return (
        <Modal open={open} setOpen={setOpen} cancelButtonRef={cancelButtonRef}>
            <div className='flex flex-wrap justify-center'>

                <Dialog.Title as="h3" className="text-center text-lg font-semibold leading-6 text-gray-950">
                    Agregar estudiante al curso
                </Dialog.Title>
                <div className='w-[80%] flex flex-col justify-start items-start min-h-[350px] mt-6'>
                    <div className='w-full mt-4'>
                        <p className="text-sm font-semibold text-center text-gray-900">Seleciona al estudiante que quieres agregar al curso</p>
                    </div>
                    <div className='w-full mt-4'>
                        <ComboBoxSearch
                            selected={formData}
                            setSelected={setFormData}
                            property='student'
                        />
                    </div>
                    {
                        action === 'request' && (
                            <p className="text-sm text-center text-gray-600 mt-6">
                                Al solicitar agregar al estudiante al curso, el estudiante podra ver el contenido del curso. Este proceso va ser valido por direccion academica.
                            </p>
                        )
                    }

                    {

                        action === 'execute' && (
                            <p className="text-sm text-center text-gray-600 mt-6">
                                Al agregar al estudiante al curso, este podra ver el contenido del curso. El alumno no podra ver el contenido si su fecha pago esta vencida.
                            </p>

                        )
                    }
                    <div className='w-full mt-[80px]'>
                        <Button
                            type="button"
                            variant="primary"
                            fullWidth
                            loading={loadingAddStudent}
                            onClick={() => handleAddStudentToCourse()}
                        >
                            {action === 'request' ? 'Solicitar agregar a este estudiante al curso' : 'Agregar estudiante al curso'}
                        </Button>
                    </div>

                </div>
            </div>
        </Modal>
    )
}
